'use client';

import a__default from "react";
import { X } from "../../../react-icons.js";
import { Button } from "../../atoms/Button/Button.js";
import { dismissLabel, variantToLabelMap } from "./InlineNotification.data.js";
function DismissButton({
  a11yLabel,
  dismissible,
  onDismiss,
  variant
}) {
  if (!dismissible) return null;
  return /* @__PURE__ */ a__default.createElement(Button, { emphasis: "low", icon: X, size: "xs", hiddenLabel: true, onClick: onDismiss }, dismissLabel(a11yLabel || variantToLabelMap[variant]));
}
export {
  DismissButton
};
